import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iCreateLibraryState {
    library_name: string;
    group_name: string;
    workflow_name?: string;
    isLoading: boolean;
    message: string | null;
    response: any[];
    errorStatus: number | null;
}

const initialState: iCreateLibraryState = {
    library_name: "",
    group_name: "",
    isLoading: false, // null이 아닌 false로
    message: "",
    response: [],
    errorStatus: null
};

// Create Library API 호출
export const createLibraryAPI = createAsyncThunk(
    "CREATE_LIBRARY",
    async (params: {library_name: string, group_name: string, workflow_name: string, assay_use: boolean, workflow_type?:string}, { rejectWithValue }) => {
        try {
            
            const pathParam = '/library/create/';
            const djangoEndpoint = getDjangoEndpoint();
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                library_name: params.library_name,
                group_name: params.group_name,
                workflow_name: params.workflow_name,
                assay_use: params.assay_use,
                workflow_type : params.workflow_type
            }, {
                withCredentials: true,
            });
            
            // 성공 시에도 status를 포함해서 반환
            return {
                data: response.data,
                status: response.status
            };
        } catch (error) {
            const errorStatus = error?.response?.status || null;
            const errorMessage = error?.response?.data?.error || error?.message || "An error occurred";
            return rejectWithValue({
                message: errorMessage,
                status: errorStatus
            });
        }
    }
);

// Create Library Slice
export const createLibrarySlice = createSlice({
    name: "createLibrary",
    initialState,
    reducers: {
        resetCreateLibrary: (state) => {
            state.response = [];
            state.message = "";
            state.isLoading = false;
            state.errorStatus = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createLibraryAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
                state.errorStatus = null;
            })
            .addCase(createLibraryAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload.data;
                state.errorStatus = action.payload.status; // 성공 시 200 등의 status
                state.message = "";
            })
            .addCase(createLibraryAPI.rejected, (state, action) => {
                state.isLoading = false;
                const payload = action.payload as { message: string; status: number | null };
                state.message = payload.message;
                state.errorStatus = payload.status; // 실패 시 400, 500 등의 status
            });
    },
});

export const { resetCreateLibrary } = createLibrarySlice.actions;
export default createLibrarySlice.reducer;